declare namespace $ {

	type $mol_view__dom_name_shm_hitalama_map_widget_float_circle_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__dom_name_space_shm_hitalama_map_widget_float_circle_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name_space'] >
	>
	type $mol_view__attr_shm_hitalama_map_widget_float_circle_3 = $mol_type_enforce<
		({ 
			'cx': string,
			'cy': string,
			'rx': string,
			'ry': string,
			'fill': ReturnType< $shm_hitalama_map_widget_float_circle['fill'] >,
			'stroke': ReturnType< $shm_hitalama_map_widget_float_circle['stroke'] >,
			'stroke-width': ReturnType< $shm_hitalama_map_widget_float_circle['stroke_width'] >,
			'vector-effect': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__dom_name_shm_hitalama_map_widget_float_circle_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__dom_name_space_shm_hitalama_map_widget_float_circle_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name_space'] >
	>
	type $mol_view__attr_shm_hitalama_map_widget_float_circle_6 = $mol_type_enforce<
		({ 
			'viewBox': string,
			'preserveAspectRatio': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_shm_hitalama_map_widget_float_circle_7 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_widget_float_circle['content_pointerdown'] > ): ReturnType< $shm_hitalama_map_widget_float_circle['content_pointerdown'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_circle_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_circle extends $shm_hitalama_map_widget_float {
		content_pointerdown( next?: any ): any
		fill( ): string
		stroke( ): string
		stroke_width( ): string
		Circle( ): $mol_view
		Svg( ): $mol_view
		scrollable( ): boolean
		controls( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=circle.view.tree.d.ts.map